import cssReset from '@clarity-website/utils/css-reset';
import { createGlobalStyle } from 'styled-components';

export default createGlobalStyle`
  ${cssReset}
  :root {
    color-scheme: light;
  }
  html, body, input, button {
    font-family: "Amazon Ember", Helvetica, sans-serif;
  }

  html, body {
    height: 100%;
    width: 100%;
    font-size: 16px;
    overflow: hidden;
    color-scheme: light;
  }

  #root {
    height: 100%;
    width: 100%;
  }
`;
